// extracted by mini-css-extract-plugin
export default {"cls1":"Autocomplete-cls1___ab737efc1cf96bb42ee","cls2":"Autocomplete-cls2___bf2545a9d4e40f9b237 Autocomplete-cls1___ab737efc1cf96bb42ee"};